// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c0bd45fe","703":"597d20fb"}[chunkId] + ".chunk.js";
};